module.exports = __webpack_public_path__ + "public/SiteIcons/listingBedIcon.svg?5eb49775";